import view from '../../view';
import constants from '../constants';

const hasSameGlobal = (global) => {
  const liveDocument = view.accessors.getLiveDocument();
  const globalElements = liveDocument.querySelectorAll(
    `${constants.GLOBAL_TAG_NAME}[src*='${global.id}']`
  );

  return globalElements.length > 1;
};

export default hasSameGlobal;
